import { createPlugin, createApiFactory, discoveryApiRef, identityApiRef, errorApiRef, fetchApiRef, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import { createSearchResultListItemExtension } from '@backstage/plugin-search-react';
import { AnnouncementsClient } from './api.esm.js';
import { rootRouteRef } from './routes.esm.js';
import { announcementsApiRef } from '@procore-oss/backstage-plugin-announcements-react';

const announcementsPlugin = createPlugin({
  id: "announcements",
  routes: {
    root: rootRouteRef
  },
  apis: [
    createApiFactory({
      api: announcementsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        errorApi: errorApiRef,
        fetchApi: fetchApiRef
      },
      factory: ({ discoveryApi, identityApi, errorApi, fetchApi }) => {
        return new AnnouncementsClient({
          discoveryApi,
          identityApi,
          errorApi,
          fetchApi
        });
      }
    })
  ]
});
const AnnouncementsPage = announcementsPlugin.provide(
  createRoutableExtension({
    name: "AnnouncementsPage",
    component: () => import('./components/Router.esm.js').then((m) => m.Router),
    mountPoint: rootRouteRef
  })
);
const AnnouncementsTimeline = announcementsPlugin.provide(
  createComponentExtension({
    name: "AnnouncementsTimeline",
    component: {
      lazy: () => import('./components/index.esm.js').then((m) => m.AnnouncementsTimeline)
    }
  })
);
const AnnouncementsCard = announcementsPlugin.provide(
  createComponentExtension({
    name: "AnnouncementsCard",
    component: {
      lazy: () => import('./components/AnnouncementsCard/index.esm.js').then((m) => m.AnnouncementsCard)
    }
  })
);
const NewAnnouncementBanner = announcementsPlugin.provide(
  createComponentExtension({
    name: "NewAnnouncementBanner",
    component: {
      lazy: () => import('./components/NewAnnouncementBanner/index.esm.js').then(
        (m) => m.NewAnnouncementBanner
      )
    }
  })
);
const AnnouncementSearchResultListItem = announcementsPlugin.provide(
  createSearchResultListItemExtension({
    name: "AnnouncementSearchResultListItem",
    component: () => import('./components/AnnouncementSearchResultListItem/index.esm.js').then(
      (m) => m.AnnouncementSearchResultListItem
    ),
    predicate: (result) => result.type === "announcements"
  })
);

export { AnnouncementSearchResultListItem, AnnouncementsCard, AnnouncementsPage, AnnouncementsTimeline, NewAnnouncementBanner, announcementsPlugin };
//# sourceMappingURL=plugin.esm.js.map
